import { render, staticRenderFns } from "./categoryBasic.vue?vue&type=template&id=b0fe4bcc&scoped=true"
import script from "./categoryBasic.vue?vue&type=script&lang=js"
export * from "./categoryBasic.vue?vue&type=script&lang=js"
import style0 from "./categoryBasic.vue?vue&type=style&index=0&id=b0fe4bcc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fe4bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0fe4bcc')) {
      api.createRecord('b0fe4bcc', component.options)
    } else {
      api.reload('b0fe4bcc', component.options)
    }
    module.hot.accept("./categoryBasic.vue?vue&type=template&id=b0fe4bcc&scoped=true", function () {
      api.rerender('b0fe4bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/categoryBasic.vue"
export default component.exports